module.exports = __webpack_public_path__ + "static/media/diebold-2.738d8ec4.svg";